import React, { useEffect } from 'react';
import { SummaryList, Button } from 'govuk-react-jsx';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import {
  getPmcCheckAnswers,
  setPmcCheckAnswers,
} from '../../features/pmc/pmcJourneySlice';
import {
  formatMobileNumber,
  formatTelephoneNumber,
} from '../../utils/format-number';
import { checkAnswers } from '../../firebase';
import useTitle from '../../hooks/useTitle';

const CheckAnswers = () => {
  const answers = useSelector(getPmcCheckAnswers);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'landlordReg.CheckAnswers.s21',
    'Check your answers - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const history = useHistory();

  const dispatch = useDispatch();

  useEffect(() => {
    checkAnswers()
      .then((response) => {
        const { data } = response;

        dispatch(setPmcCheckAnswers(data));
      })
      .catch(() => {
        // TODO: Show error message
      });
  }, []);

  const handleBtnClick = () => {
    history.push('/pmcReg/declaration');
  };

  const pageModel = (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy('pmcReg.CheckAnswers.s1', 'Check your answers')}
      </h1>
      <h2 className="govuk-heading-m">
        {copyProvider.getCopy('pmcReg.CheckAnswers.s2', 'Account details')}
      </h2>
      {answers && (
        <SummaryList
          className="govuk-summary-list govuk-!-margin-bottom-9"
          rows={[
            {
              key: {
                children: copyProvider.getCopy(
                  'pmcReg.CheckAnswers.s3',
                  'Registered email'
                ),
              },
              value: {
                children: <p className="govuk-body">{answers.accountEmail}</p>,
              },
            },
            {
              key: {
                children: copyProvider.getCopy(
                  'pmcReg.CheckAnswers.s4',
                  'Type of account'
                ),
              },
              value: {
                children: <p className="govuk-body ">{answers.accountType}</p>,
              },
            },
            {
              key: {
                children: copyProvider.getCopy(
                  'pmcReg.CheckAnswers.s5',
                  'Name'
                ),
              },
              value: {
                children: (
                  <p className="govuk-body ">
                    {answers.firstName} {answers.lastName}
                  </p>
                ),
              },
            },
            {
              key: {
                children: copyProvider.getCopy(
                  'pmcReg.CheckAnswers.s6',
                  'Role within the business'
                ),
              },
              value: {
                children: (
                  <p className="govuk-body">{answers.roleWithinBusiness}</p>
                ),
              },
            },
            {
              key: {
                children: copyProvider.getCopy(
                  'pmcReg.CheckAnswers.s7',
                  'Mobile number'
                ),
              },
              value: {
                children: (
                  <p className="govuk-body ">
                    {formatMobileNumber(answers.mobileNumber)}
                  </p>
                ),
              },
            },

            answers.phoneNumber && {
              key: {
                children: copyProvider.getCopy(
                  'pmcReg.CheckAnswers.s8',
                  'Office landline number'
                ),
              },
              value: {
                children: (
                  <p className="govuk-body ">
                    {formatTelephoneNumber(answers.phoneNumber)}
                  </p>
                ),
              },
            },
          ]}
        />
      )}

      <h2 className="govuk-heading-m">
        {copyProvider.getCopy('pmcReg.CheckAnswers.s9', 'Business details')}
      </h2>
      {answers && (
        <SummaryList
          className="govuk-summary-list govuk-!-margin-bottom-9"
          rows={[
            answers.companyRegNumber && {
              key: {
                children: copyProvider.getCopy(
                  'pmcReg.CheckAnswers.s10',
                  'Companies House number'
                ),
              },
              value: {
                children: (
                  <p className="govuk-body">{answers.companyRegNumber}</p>
                ),
              },
            },

            answers.vatRegNumber && {
              key: {
                children: copyProvider.getCopy(
                  'pmcReg.CheckAnswers.s14',
                  'VAT registration number'
                ),
              },
              value: {
                children: (
                  <p className="govuk-body">
                    {answers.vatRegNumber && answers.vatRegNumber}
                  </p>
                ),
              },
            },

            answers.businessName && {
              key: {
                children: copyProvider.getCopy(
                  'pmcReg.CheckAnswers.s11',
                  'Company name'
                ),
              },
              value: {
                children: <p>{answers.businessName}</p>,
              },
            },

            answers.businessAddressLine1 && {
              key: {
                children: copyProvider.getCopy(
                  'pmcReg.CheckAnswers.s12',
                  'Registered company address'
                ),
              },
              value: {
                children: (
                  <div key="0" className="govuk-body">
                    <p className="govuk-body">
                      <section>
                        {answers.businessAddressLine1 &&
                          `${answers.businessAddressLine1},`}
                      </section>
                      <section>
                        {answers.businessAddressLine2 &&
                          `${answers.businessAddressLine2},`}
                      </section>
                      <section>
                        {answers.businessAddressCity &&
                          `${answers.businessAddressCity},`}
                      </section>
                      <section>
                        {answers.businessAddressCounty &&
                          `${answers.businessAddressCounty},`}
                      </section>
                      <section>
                        {answers.businessAddressPostcode &&
                          answers.businessAddressPostcode}
                        {answers.businessAddressCountry && ','}
                      </section>
                      <section>
                        {answers.businessAddressCountry &&
                          answers.businessAddressCountry}
                      </section>
                    </p>
                  </div>
                ),
              },
            },
          ]}
        />
      )}

      <Button
        className="govuk-button govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy(
          'pmcReg.CheckAnswers.s13',
          'Confirm and continue'
        )}
      </Button>
    </>
  );
  return pageModel;
};

export default CheckAnswers;
